import _styled from "@emotion/styled-base";
var _excluded = ["offset", "visibilityThreshold", "always"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from "react";
import useScrollIntoView, { scrollIntoViewDefaults } from "./useScrollIntoView";
import { jsx as ___EmotionJSX } from "@emotion/core";

var HiddenElement = _styled("span", {
  target: "ez6m3w30"
})({
  name: "199snly-base",
  styles: "label:base;visibility:hidden;"
});

export default function ScrollIntoView(_ref) {
  var offset = _ref.offset,
      visibilityThreshold = _ref.visibilityThreshold,
      always = _ref.always,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var scrollToElementRef = useScrollIntoView({
    offset: offset,
    visibilityThreshold: visibilityThreshold,
    always: always
  });
  return ___EmotionJSX(HiddenElement, _extends({
    ref: scrollToElementRef
  }, props));
}
ScrollIntoView.defaultProps = scrollIntoViewDefaults;